import DriverValidationComplaintsContainer from './containers/DriverValidationComplaintsContainer';

export default DriverValidationComplaintsContainer;
export {uiDataDriverValidationComplaints, serverDataDriverValidationComplaints} from './reducers/DriverValidationComplaints';

